import React from 'react';
import { Box } from 'components';
import { Item, Icon, Header } from 'semantic';
import widgetstyles from './widgetstyles.module.less';
import { useTranslation } from 'react-i18next';
import { Account } from 'types/account';
import { getTier } from 'utils/installer-partner-program';

export default function PaternProgramStats({
  installerPartnerProgram,
}: {
  installerPartnerProgram: Account['installerPartnerProgram'];
}) {
  const { t } = useTranslation();

  if (!installerPartnerProgram?.currentTier) {
    return null;
  }

  const currentTier = getTier(installerPartnerProgram.currentTier, t);

  return (
    <>
      <Box condensed>
        <Box.Content>
          <div className={widgetstyles.itemGrid}>
            <div className={widgetstyles.itemGridColumn}>
              <Item.Group unstackable className={widgetstyles.itemGroup}>
                <Item>
                  <Item.Image>
                    <Icon
                      name={currentTier.iconName}
                      className={widgetstyles.itemIcon}
                    />
                  </Item.Image>
                  <Item.Content verticalAlign="middle">
                    <Header as="div">
                      {t(
                        'maintenanceHome.patnerProgramStatsActiveEvses',
                        '{{activeConnectors}} Active Connectors',
                        {
                          activeConnectors:
                            installerPartnerProgram?.currentConnectorsCount ||
                            0,
                        }
                      )}
                    </Header>
                    <div className={widgetstyles.itemSubheader}>
                      {currentTier.label}
                    </div>
                  </Item.Content>
                </Item>
              </Item.Group>
            </div>
          </div>
        </Box.Content>

        <Box.Actions>
          <Box.ActionLink to="/maintenance/evse-controllers?isPartnerProgramEligible=true">
            {t('maintenanceHome.viewEvses', 'View EVSEs')}
          </Box.ActionLink>

          <Box.ActionLink to="/settings/account/installer/partner-program">
            {t('maintenanceHome.viewProgram', 'View Program')}
          </Box.ActionLink>
        </Box.Actions>
      </Box>
    </>
  );
}
